export default __webpack_public_path__ + "896f278b47f98e1e1751a1f13ecfc9dc.png";